import { Pipe, PipeTransform } from '@angular/core';
import { formatVehicleDescription, VehicleDescriptionParts } from '../utils/vehicle-utils';

/**
 * Renders a vehicle as "year make model", skipping missing parts. Template counterpart of
 * {@link formatVehicleDescription}, so a template never builds the label with a string literal that
 * would print "null" for a federation vehicle without a year.
 */
@Pipe({
    name: 'vehicleDescription',
})
export class VehicleDescriptionPipe implements PipeTransform {
    transform(vehicle: VehicleDescriptionParts | null | undefined): string {
        return formatVehicleDescription(vehicle);
    }
}
